import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { usePrevious } from '@radix-ui/react-use-previous';
import { forwardRef, useRef, useEffect } from 'react';

const BubbleSelect = forwardRef((props, forwardedRef) => {
  const { value, ...selectProps } = props;
  const ref = useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const prevValue = usePrevious(value);
  useEffect(() => {
    const select = ref.current;
    const selectProto = window.HTMLSelectElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(
      selectProto,
      "value"
    );
    const setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      const event = new Event("change", { bubbles: true });
      setValue.call(select, value);
      select.dispatchEvent(event);
    }
  }, [prevValue, value]);
  return /* @__PURE__ */ jsx("select", { ...selectProps, ref: composedRefs, defaultValue: value, children: /* @__PURE__ */ jsx("option", { value }) });
});

export { BubbleSelect as default };
//# sourceMappingURL=BubbleSelect.mjs.map
